const Requests = { counter: 0};
export default Requests;
